package com.karawek.core.ui.theme

import androidx.compose.ui.tooling.preview.PreviewParameterProvider

enum class ThemeMode {
    System,
    Light,
    Dark,
}

class ThemeModeProvider : PreviewParameterProvider<ThemeMode> {
    override val values: Sequence<ThemeMode>
        get() = sequenceOf(ThemeMode.Light, ThemeMode.Dark)
}
